// extracted by mini-css-extract-plugin
module.exports = {"typeDistribution":"TypeDistributionPanel_typeDistribution__LkquN","noData":"TypeDistributionPanel_noData__05CUf"};